var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedHijau(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8776 5.75625L7.81886 8.17208C7.39562 8.66873 7.184 8.91705 6.9056 8.91705C6.6272 8.91705 6.41558 8.66873 5.99234 8.17208L5.1224 7.15125M3.69276 3.44229C4.61274 3.6678 5.54975 3.13879 5.81003 2.24693C6.29524 0.584356 8.70476 0.584356 9.18997 2.24693C9.45025 3.13879 10.3873 3.6678 11.3072 3.44229C13.0223 3.02191 14.227 5.06244 12.9972 6.30464C12.3375 6.97099 12.3375 8.02901 12.9972 8.69536C14.227 9.93756 13.0223 11.9781 11.3072 11.5577C10.3873 11.3322 9.45025 11.8612 9.18997 12.7531C8.70476 14.4156 6.29524 14.4156 5.81003 12.7531C5.54975 11.8612 4.61274 11.3322 3.69276 11.5577C1.97774 11.9781 0.772983 9.93756 2.00279 8.69536C2.66249 8.02901 2.66249 6.97099 2.00279 6.30464C0.772983 5.06244 1.97774 3.02191 3.69276 3.44229Z",
    stroke: "#27AE60",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedHijau);
export default __webpack_public_path__ + "static/media/verifiedHijau.ffacd92354947ca10ba320995ebeb5e0.svg";
export { ForwardRef as ReactComponent };